var _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _circle, _path4, _circle2, _path5, _circle3, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path6, _polygon, _path7, _polygon2, _polyline, _rect19, _rect20, _line, _rect21, _rect22, _rect23, _rect24, _rect25, _circle4, _circle5, _rect26, _rect27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntrologo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 294.29,
    y: 43.75,
    width: 60.07,
    height: 41.3,
    fill: "#ffd200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.25,72.51a1.41,1.41,0,0,1-.86-.3l-9-7.12a1.35,1.35,0,0,1-.53-1.08,1.38,1.38,0,0,1,.52-1.09l9-7.25a1.39,1.39,0,1,1,1.75,2.17L309.48,64l7.64,6a1.39,1.39,0,0,1-.87,2.48Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M332.56,72.51A1.39,1.39,0,0,1,331.7,70l7.63-6-7.64-6.15a1.39,1.39,0,1,1,1.74-2.17l9,7.25A1.34,1.34,0,0,1,343,64a1.37,1.37,0,0,1-.52,1.08l-9,7.12A1.41,1.41,0,0,1,332.56,72.51Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.63,72.51a1.33,1.33,0,0,1-.58-.13,1.39,1.39,0,0,1-.69-1.84l6.56-14.37a1.4,1.4,0,0,1,1.85-.68,1.38,1.38,0,0,1,.68,1.84L321.89,71.7A1.39,1.39,0,0,1,320.63,72.51Z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8,
    y: 40.58,
    width: 67.91,
    height: 113.64,
    fill: "#24285b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 148.7,
    y: 41,
    width: 125.79,
    height: 87.59,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 148.7,
    y: 128.58,
    width: 125.79,
    height: 86,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 162.44,
    y: 142.41,
    width: 99.51,
    height: 40.84,
    fill: "#c9c9c9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 191.75,
    y: 188.32,
    width: 39.54,
    height: 18.94,
    fill: "#c9c9c9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 156.91,
    y: 49.14,
    width: 109.25,
    height: 69.02,
    fill: "#24285b"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 188.83,
    y: 97.08,
    width: 35.09,
    height: 3.93,
    fill: "#68e1fd"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 198.9,
    y: 86.14,
    width: 31.37,
    height: 3.93,
    fill: "#ffd200"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 198.9,
    y: 106.57,
    width: 41.82,
    height: 3.93,
    fill: "#68e1fd"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 175.81,
    y: 106.57,
    width: 15.73,
    height: 3.93,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 165.75,
    y: 97.08,
    width: 15.73,
    height: 3.93,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164.06,
    cy: 55.76,
    r: 1.85,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.83,150.23s13.06-2.72,10.07,9.88,7,10.89,5.06,20.76-15.13,33.71-15.13,33.71H164.06l12.6-46.43Z",
    opacity: 0.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.56,
    cy: 55.76,
    r: 1.85,
    fill: "#68e1fd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M248.67,154.94s12.24-5.64,17.48,5.08,8.34,13.49,8.34,13.49v33.75l-26.84-20.17Z",
    opacity: 0.08
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.75,
    cy: 55.76,
    r: 1.85,
    fill: "#ffd200"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 165.75,
    y: 67.21,
    width: 15.73,
    height: 3.93,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 175.81,
    y: 77.03,
    width: 15.73,
    height: 3.93,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 198.9,
    y: 77.03,
    width: 31.37,
    height: 3.93,
    fill: "#ffd200"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 175.81,
    y: 86.14,
    width: 15.73,
    height: 3.93,
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 187.76,
    y: 67.21,
    width: 32.4,
    height: 3.93,
    fill: "#68e1fd"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 226.94,
    y: 67.21,
    width: 23,
    height: 3.93,
    fill: "#68e1fd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M247.65,194.74s-16.59-4.08-15.32-14,12-4.34,12-4.34-2.81-13.51-6.89-17.35,4.59-10.44,11.23-4.07,7.92,1.26,13.28,7.89,5.36,25.49,5.36,25.49Z",
    fill: "#f4a28c"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "247.65 194.75 261.95 251.43 293.1 239.17 267.31 188.32 247.65 194.75",
    fill: "#68e1fd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.8,189.38s16.59-4.09,15.32-14-12-4.34-12-4.34,2.8-13.5,6.89-17.35-4.6-10.43-11.24-4.07-7.91,1.26-13.27,7.9S159.14,183,159.14,183Z",
    fill: "#f4a28c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.8 189.38 164.5 246.06 133.35 233.8 159.14 182.95 178.8 189.38",
    fill: "#68e1fd"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "83.74 75.36 108.66 75.36 108.66 116.72",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 73.01,
    y: 50.49,
    width: 32.94,
    height: 5.27,
    fill: "#ffd200"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 75.06,
    y: 69.97,
    width: 17.36,
    height: 10.78,
    fill: "#68e1fd"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 83.74,
    y1: 116.72,
    x2: 108.37,
    y2: 116.72,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 99.98,
    y: 91.16,
    width: 17.36,
    height: 10.78,
    fill: "#68e1fd"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 75.06,
    y: 111.33,
    width: 17.36,
    height: 10.78,
    fill: "#68e1fd"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 99.69,
    y: 111.33,
    width: 17.36,
    height: 10.78,
    fill: "#68e1fd"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 75.06,
    y: 136.53,
    width: 42,
    height: 7.66,
    fill: "#fff",
    opacity: 0.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 294.08,
    y: 103.91,
    width: 69.87,
    height: 40.41,
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.02,
    cy: 116.76,
    r: 4.06,
    fill: "#24285b"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.02,
    cy: 130.89,
    r: 4.06,
    fill: "#68e1fd"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 315.4,
    y: 113.99,
    width: 36.61,
    height: 4.94,
    fill: "#c9c9c9"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 315.4,
    y: 128.28,
    width: 36.61,
    height: 4.94,
    fill: "#c9c9c9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntrologo);
export default __webpack_public_path__ + "static/media/intrologo.5e53906f63009dc86e3a123cd8fcfa5a.svg";
export { ForwardRef as ReactComponent };